import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import type { WidgetProps } from '../registry';

export const SimpleDateTimeWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
  onBlur,
  error,
  warning,
}) => {
  const value = widget.value ? dayjs(widget.value) : null;

  return (
    <div className="rul-widget-field">
      {widget.label && (
        <label className="rul-widget-field-label">
          {widget.label}
          {widget.required && <span className="required">*</span>}
        </label>
      )}
      <DatePicker
        showTime={{ format: 'HH:mm' }}
        value={value}
        placeholder={widget.placeholder}
        disabled={widget.disabled}
        status={error ? 'error' : warning ? 'warning' : ''}
        format="D. MMM YYYY HH:mm"
        style={{ width: '100%' }}
        size="large"
        onChange={(datetime) => {
          const formattedValue = datetime
            ? datetime.format('YYYY-MM-DDTHH:mm:ss')
            : null;
          onChange?.(widget.name, formattedValue);
          // DatePicker triggers blur on selection, so also call onBlur
          onBlur?.(widget.name, formattedValue);
        }}
      />
      {error && <div className="rul-widget-error">{error}</div>}
      {warning && !error && <div className="rul-widget-warning">{warning}</div>}
    </div>
  );
};
